import React from "react";
import Icon from "../atoms/Icon";
import { joinClasses } from "../../utils/textUtils";

interface Props {
  small?: boolean;
  normal?: boolean;
  big?: boolean;
  wide?: boolean;
  secondary?: boolean;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: (e: any) => void;
  iconStart?: string;
  iconEnd?: string;
  className?: string;
  baseClass?: string;
  style?: React.CSSProperties;
  children: any;
}

export default function Button(props: Props) {
  const {
    small,
    normal,
    big,
    wide,
    secondary,
    type,
    disabled,
    onClick,
    iconStart,
    iconEnd,
    className,
    baseClass = "btn-custom",
    style,
    children,
  } = props;

  let size, wideClass, secondaryClass;

  if (props) {
    if (small) size = "small";
    if (normal) size = "normal";
    if (big) size = "big";
    if (wide) wideClass = "wide";
    if (secondary) secondaryClass = "secondary";
  }

  return (
    <button
      type={type}
      disabled={disabled}
      className={joinClasses([
        baseClass,
        secondaryClass,
        wideClass,
        size,
        className,
      ])}
      style={style}
      onClick={onClick}
    >
      {iconStart ? <Icon i={iconStart} /> : null}
      <span>{children}</span>
      {iconEnd ? <Icon i={iconEnd} /> : null}
    </button>
  );
}
